var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-100"},[_c('review-rating',{attrs:{"rating":_vm.value,"editable":true},on:{"clicked":function($event){_vm.value = $event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }